import * as Cesium from "cesium";
import { CENTER } from "./effectConfig";

/** 银川平原海拔大致范围，用于过滤错误采样 */
const YC_MIN = 800;
const YC_MAX = 1600;
const FALLBACK = 1110;

function isPlausible(h) {
  return Number.isFinite(h) && h >= YC_MIN && h <= YC_MAX;
}

/**
 * 采样地表高度（相对椭球面）。
 * 优先 terrain 采样（不依赖瓦片是否已渲染）；scene 采样易在首屏得到错误的低值。
 */
export async function sampleGroundHeight(
  viewer,
  lng = CENTER.lng,
  lat = CENTER.lat
) {
  // 1) 地形 provider 精确采样
  try {
    const terrain = viewer.terrainProvider;
    if (terrain && !(terrain instanceof Cesium.EllipsoidTerrainProvider)) {
      // 等地形就绪（Ion world terrain）
      if (terrain.readyPromise) {
        await terrain.readyPromise;
      }
      const carto = Cesium.Cartographic.fromDegrees(lng, lat);
      const [sampled] = await Cesium.sampleTerrainMostDetailed(terrain, [
        carto,
      ]);
      if (isPlausible(sampled?.height)) {
        console.log("[sampleGroundHeight] terrain:", sampled.height);
        return sampled.height;
      }
    }
  } catch (e) {
    console.warn("[sampleGroundHeight] terrain 采样失败:", e);
  }

  // 2) 场景拾取（地形瓦片已显示时）
  try {
    const carto = Cesium.Cartographic.fromDegrees(lng, lat);
    const updated = await viewer.scene.sampleHeightMostDetailed([carto]);
    const h = updated?.[0]?.height;
    if (isPlausible(h)) {
      console.log("[sampleGroundHeight] scene:", h);
      return h;
    }
    if (Number.isFinite(h)) {
      console.warn(
        `[sampleGroundHeight] scene 高度 ${h} 不在银川合理范围，忽略`
      );
    }
  } catch (e) {
    console.warn("[sampleGroundHeight] sampleHeight 失败:", e);
  }

  console.warn("[sampleGroundHeight] 使用回退高度:", FALLBACK);
  return FALLBACK;
}
